import React, { useState } from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { API } from "../../../../../shared/services";
import { toast } from "react-toastify";
import { IconModal } from "../../IconModal";
import { useTranslation } from "react-i18next";
import { useContactsState } from "modules/app/contexts";

function ForwardCustomer({ customer }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState();
  const [users, setUsers] = useState([]);
  const { t } = useTranslation(["forward"]);
  const { currentContact } = useContactsState();

  const user = users.filter((user) => {
    if (user?.status === "active") {
      return user;
    }
  });

  function changeUser(user) {
    API.put(`customers/${customer.id}`, {
      customer: {
        user: { id: user.id },
      },
    })
      .then(function () {
        setOpen(false);
        toast.success(t("forward:success"));
      })
      .catch(function () {
        toast.error(t("forward:error"));
      });
  }

  function loadUsers() {
    API.get("users")
      .then((result) => {
        const filteredUsers = result.data.filter(
          (item) => item.id !== currentContact?.user?.id
        );
        setUsers(filteredUsers);
      })
      .catch(() => {
        setError(
          <Alert variant="outlined" severity="error">
            {t("forward:not_loading")}
          </Alert>
        );
      });
  }
  return (
    <IconModal
      title="Encaminhar contato"
      handleOpenModal={loadUsers}
      open={open}
      setOpen={setOpen}
      icon={
        <strong style={{ color: "#000", fontSize: 16 }}>
          {t("forward:title")}
        </strong>
      }
    >
      {!!error && error}
      <List>
        {user.map((user) => (
          <ListItem key={user.id} button onClick={() => changeUser(user)}>
            <ListItemText primary={user.name} />
          </ListItem>
        ))}
      </List>
    </IconModal>
  );
}

export default ForwardCustomer;
